/** @format */

import {styled} from '@mui/material/styles';
import {Box, Button, Typography} from '@mui/material';

export const HeaderBox = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '400px',
  height: '48px',
  gap: theme.spacing(4),
  padding: theme.spacing(0, 2, 0, 4),
  background: '#D0E7FB',
}));

export const HeaderText = styled(Typography)(() => ({
  color: '#051522',
  fontSize: '18px',
  fontWeight: 400,
  lineHeight: '22px',
}));

export const ContentBox = styled(Box)(({theme}) => ({
  width: '400px',
  padding: theme.spacing(4),
  background: theme.palette.figma_gray_light_4?.main,
}));

export const CloseButton = styled(Button)(({theme}) => ({
  minWidth: '48px',

  '.MuiSvgIcon-root': {
    color: theme.palette.figma_primary?.dark,
  },
}));
